<script setup>
import { AtSymbolIcon, DevicePhoneMobileIcon, FingerPrintIcon, UserIcon } from '@heroicons/vue/24/outline'
import { onMounted, ref } from 'vue'

const icons = {
    user: UserIcon,
    phone: DevicePhoneMobileIcon,
    email: AtSymbolIcon,
    verification: FingerPrintIcon,
}

defineProps({
    modelValue: String,

    suffix: {
        type: String,
        required: false,
    },

    icon: {
        type: String,
        required: false,
    },

    id: {
        type: String,
        required: false,
    },

    placeholder: {
        type: String,
        required: false,
    },

    autocomplete: {
        type: String,
        required: false,
    },

    type: {
        type: String,
        default: 'text',
    },
})

defineEmits(['update:modelValue'])

const input = ref(null)

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus()
    }
})

defineExpose({ focus: () => input.value.focus() })
</script>

<template>
    <div
        v-if="icon"
        class="flex items-center"
    >
        <p class="rounded-l-lg border border-r-0 border-gray-600 bg-gray-100">
            <span class="flex h-10 w-10 items-center justify-center p-2 text-gray-500">
                <component :is="icons[icon]" />
            </span>
        </p>

        <input
            ref="input"
            class="focus:outline-brand-orange block w-full rounded-r-md bg-white px-3.5 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            :placeholder="placeholder ?? ''"
            :autocomplete="autocomplete ?? 'off'"
            :id="id ?? ''"
            :type="type"
        />
    </div>

    <div
        v-else-if="suffix"
        class="flex items-center"
    >
        <p class="rounded-l-lg border border-r-0 border-gray-600 bg-gray-100">
            <span class="flex h-10 w-10 items-center justify-center p-2 text-gray-500">
                {{ suffix }}
            </span>
        </p>

        <input
            ref="input"
            class="focus:outline-brand-orange block w-full rounded-r-md bg-white px-3.5 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            :placeholder="placeholder ?? ''"
            :autocomplete="autocomplete ?? 'off'"
            :id="id ?? ''"
            :type="type"
        />
    </div>

    <input
        v-else
        ref="input"
        class="focus:outline-brand-orange block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        :placeholder="placeholder ?? ''"
        :autocomplete="autocomplete ?? 'off'"
        :id="id ?? 'standard-input'"
        :type="type"
    />
</template>
